module.exports = __webpack_public_path__ + "static/media/up-arrow.ebdae7bd.svg";